import { DialogContent, DialogContentText } from "@mui/material";
import moment from "moment";
import React from "react";
import { VISIBILITY, VISIBILITY_MAP } from "utils/constants";

const DialogDatasetContent = ({ dataset }) => {
    return (
        <DialogContent>
            <DialogContentText>
                <strong>Nombre:</strong> {dataset.name}
            </DialogContentText>
            <DialogContentText>
                <strong>Visibilidad:</strong> {dataset.visibility}
            </DialogContentText>
            <DialogContentText>
                <strong>Encabezados:</strong> {dataset.headers || "N/A"}
            </DialogContentText>
            <DialogContentText>
                <strong>Descripción:</strong> {dataset.description || "Sin descripción"}
            </DialogContentText>
            <DialogContentText>
                <strong>Propietario:</strong> {dataset.owner}
            </DialogContentText>
            <DialogContentText>
                <strong>Establecimiento:</strong> {dataset.establishment}
            </DialogContentText>
            <DialogContentText>
                <strong>Tamaño del archivo:</strong>{" "}
                {dataset.file_size ? `${dataset.file_size} MB` : "Desconocido"}
            </DialogContentText>
            <DialogContentText>
                <strong>Fecha de creación:</strong> {dataset.createdAt}
            </DialogContentText>
        </DialogContent>
    );
};

export default DialogDatasetContent;
